<template>
  <div v-if="project" class="header-wrapper">
    <!-- Bara PNRR -->
    <!-- <div class="funding-header">
      <img
        src="@/assets/icons/logo_ue.png"
        alt="Finanțat de Uniunea Europeană - NextGenerationEU"
        class="funding-logo funding-logo-eu"
      />

      <img src="@/assets/icons/logo_gr.png" alt="Guvernul României" class="funding-logo funding-logo-government" />

      <img
        src="@/assets/icons/logo_pnrr.png"
        alt="Planul Național de Redresare și Reziliență"
        class="funding-logo funding-logo-pnrr"
      />
    </div> -->

    <!-- Header-ul SF-->
    <header class="header">
      <!-- mobil: logo + icons -->
      <div v-if="isMobile" class="mobile-app-banner">
        <img
          class="mobile-logo clickable-logo"
          :src="hostAddress + project.logo"
          alt="Project Logo"
          @click="restartMap"
        />

        <div class="mobile-app-icons">
          <a
            v-if="project.cityapp && project.cityapp.app_store_url"
            :href="project.cityapp.app_store_url"
            target="_blank"
          >
            <span class="material-icons-round" style="font-size: 28px">
              apple
            </span>
          </a>

          <a
            v-if="project.cityapp && project.cityapp.play_store_url"
            :href="project.cityapp.play_store_url"
            target="_blank"
          >
            <img src="@/assets/icons/robot.png" alt="Android" width="20" />
          </a>
        </div>
      </div>

      <!-- desktop/iPad -->
      <div v-if="project.logo && !isMobile" class="logo">
        <img
          class="logo-img clickable-logo"
          :src="hostAddress + project.logo"
          alt="Project Logo"
          width="277"
          height="47"
          @click="restartMap"
        />
      </div>

      <div v-if="!isMobile" class="icon-bar">
        <a
          v-if="
            project.cityapp &&
              project.cityapp.app_store_url &&
              !project.cityapp.app_store_url.toLowerCase().includes('empty')
          "
          class="icon-button"
          :href="project.cityapp.app_store_url"
          target="_blank"
        >
          <span class="material-icons-round" style="font-size: 28px">
            apple
          </span>
        </a>

        <a
          v-if="
            project.cityapp &&
              project.cityapp.play_store_url &&
              !project.cityapp.play_store_url.toLowerCase().includes('empty')
          "
          class="icon-button"
          :href="project.cityapp.play_store_url"
          target="_blank"
        >
          <img src="@/assets/icons/robot.png" alt="Android" width="20" />
        </a>

        <div v-if="project.cityapp && project.cityapp.website_url" class="icon-button">
          <span class="material-icons-round">language</span>
        </div>

        <div v-if="project.cityapp && project.cityapp.facebook_url" class="icon-button">
          <span class="material-icons-round">facebook</span>
        </div>

        <div v-if="project.cityapp && project.cityapp.instagram_url" class="icon-button">
          <img src="@/assets/icons/instagram_24_24.png" alt="Instagram" width="24" />
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    hostAddress: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isMobile: false
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    restartMap() {
      this.$emit("restart-map");
    }
  }
};
</script>

<style scoped>
.header-wrapper {
  width: 100%;
  position: relative;
  z-index: 40002;
}

.funding-header {
  /* height: 52px; */
  height: 80px;
  width: 100%;
  /* background: linear-gradient(to right, rgb(205, 214, 223), rgba(255, 255, 255, 0.521)); */
  background: #e0e0e0;
  /* background: #ffffff; */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.18);

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 25%;
  box-sizing: border-box;
}

.funding-logo {
  display: block;
  width: auto;
  max-height: 60px;
  object-fit: contain;
}

.funding-logo-eu {
  height: 60px;
}

.funding-logo-government {
  height: 50px;
}

.funding-logo-pnrr {
  height: 44px;
}
.header.header {
  height: 60px;
  background: linear-gradient(to right, rgb(205, 214, 223), rgba(255, 255, 255, 0.521));
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-family: "Quicksand", sans-serif;
  z-index: 40002;
  position: relative;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.027);
}

.icon-bar {
  display: flex;
  gap: 10px;
  flex-direction: row-reverse;
}

.icon-button {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.icon-button:hover {
  background: #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.icon-button img {
  display: block;
}

@media (max-width: 768px) {
  .mobile-app-banner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    gap: 16px;
    width: 100%;
  }

  .mobile-logo {
    height: 40px;
    width: auto;
  }

  .mobile-app-icons {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  .mobile-app-icons img,
  .mobile-app-icons .material-icons-round {
    width: 28px;
    height: 28px;
  }
}

.clickable-logo {
  cursor: pointer;
}

@media (max-width: 768px) {
  .funding-header {
    height: 55px;
    padding: 0 10px;
    gap: 15px;
    justify-content: space-between;
  }

  .funding-logo-eu {
    height: 34px;
  }

  .funding-logo-government {
    height: 34px;
  }

  .funding-logo-pnrr {
    height: 34px;
  }
}
</style>
